import React, { Component } from "react";

import style from "./style.module.css";

export default class PlayerAdditionalModal extends Component {
  render() {
    return <div className={style.container}>{this.props.children}</div>;
  }
}
